import { type FC, type ReactNode } from "react";

import { faChevronUp } from "@fortawesome/pro-duotone-svg-icons/faChevronUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Over a Drafting case's sections: the title, the action that adds one and
// the chevron that closes them (`onClose`), then where they come from.
export const SectionsHeader: FC<{
  line: ReactNode;
  action: ReactNode;
  onClose?(): void;
}> = ({ line, action, onClose }) => (
  <div>
    <div className="flex items-center justify-between gap-2">
      <h3 className="text-[13px] font-semibold text-slate-800">
        Your sections
      </h3>
      <div className="flex shrink-0 items-center gap-1">
        {action}
        {onClose && (
          <button
            type="button"
            aria-label="Close your sections"
            onClick={onClose}
            className="flex size-8 items-center justify-center rounded-full text-slate-500 hover:bg-slate-100"
          >
            <FontAwesomeIcon icon={faChevronUp} />
          </button>
        )}
      </div>
    </div>
    <p className="text-[11.5px] text-slate-500">{line}</p>
  </div>
);

// The sections panel: his template mapped onto this report, apart from the
// chat, so it reads differently. It sits inset in the pane and scrolls with it.
export const SectionsPanel: FC<{ children: ReactNode }> = ({ children }) => (
  <section
    aria-label="Your sections"
    className="space-y-2 rounded-[14px] border border-slate-300 bg-slate-100 p-3"
  >
    {children}
  </section>
);
